import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const SOCIAL_CONFIG = [
  { key: 'facebook', fabClass: 'fab fa-facebook-f', label: 'Facebook' },
  { key: 'twitter', fabClass: 'fab fa-twitter', label: 'X / Twitter' },
  { key: 'instagram', fabClass: 'fab fa-instagram', label: 'Instagram' },
  { key: 'linkedin', fabClass: 'fab fa-linkedin-in', label: 'LinkedIn' },
  { key: 'youtube', fabClass: 'fab fa-youtube', label: 'YouTube' },
  { key: 'whatsapp', fabClass: 'fab fa-whatsapp', label: 'WhatsApp' },
];

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState({});

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/api/cms/social-links`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setSocialLinks(data.data || {});
      })
      .catch(() => {});
  }, []);

  const activeLinks = SOCIAL_CONFIG.filter((s) => socialLinks[s.key]);

  return (
    <footer className="uc-footer">
      <div className="uc-container">
        <div className="uc-footer__grid">
          <div className="uc-footer__brand">
            <Link to="/" aria-label="Home">
              {/* white lockup — the footer sits on the Uber black band */}
              <img alt="JobHub" src="/assets/imgs/theme/admin-logo.svg" />
            </Link>
            <p className="uc-lede" style={{ fontSize: '0.9375rem', maxWidth: 320 }}>
              A multi-company job marketplace connecting candidates with employers hiring
              across the country.
            </p>
            <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { icon: <Mail size={15} />, text: 'contact@bharat-online.com' },
                { icon: <Phone size={15} />, text: '+91 80108 44476' },
                { icon: <MapPin size={15} />, text: 'India' },
              ].map((item, i) => (
                <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.875rem', color: 'rgba(255,255,255,0.65)' }}>
                  {item.icon} {item.text}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h6>Company</h6>
            <ul className="uc-footer__links">
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact</Link>
              </li>
              <li>
                <Link to="/blog-grid">Career insights</Link>
              </li>
              <li>
                <Link to="/next-gen-training">Next gen training</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="uc-footer__bottom">
          <span className="uc-footer__legal">
            <span>
              Copyright ©{new Date().getFullYear()}
              {' ·'} All rights reserved.
            </span>
            <a
              className="uc-footer__legal-logo"
              href="https://bharat-online.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Bharat Online — bharat-online.com"
              title="bharat-online.com"
            >
              <img src="/assets/imgs/theme/BOL.png" alt="Bharat Online" />
            </a>
          </span>

          {activeLinks.length > 0 && (
            <div className="uc-social">
              {activeLinks.map((s) => (
                <a
                  key={s.key}
                  href={socialLinks[s.key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                >
                  <i className={s.fabClass} aria-hidden="true" />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
